import {partition, pipe} from 'ramda';

export function moveToHeadById<T extends {id: string}>(id: string, array: T[]): T[] {
  return pipe(
    partition((item: T) => item.id === id),
    ([match, rest]) => match.concat(rest)
  )(array);
}
